/** App Store / Play listing URLs (home hero + public match store CTAs). */
export const LANDING_APP_STORE_URL =
  'https://apps.apple.com/us/app/clube-do-tennis/id6747998672'
export const LANDING_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=br.com.clubedotennis.app'
